import { render } from "./Candidatedetails.vue?vue&type=template&id=a1617d1a&scoped=true"
import script from "./Candidatedetails.vue?vue&type=script&lang=js"
export * from "./Candidatedetails.vue?vue&type=script&lang=js"

import "./Candidatedetails.vue?vue&type=style&index=0&id=a1617d1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1617d1a"]])

export default __exports__